import { formatLabel, optionsHorizontalBar } from "./utils"

const cd_direct_recovery_income = {
  figureNumber: "2.3",
  title: "Income Group",
  subTitle: "FY 2022 (percentage share of total)",
  source: "Sources: IMF, Capacity Development Management and Administration Program; and IMF staff calculations. /n Note: Advanced economies are as classified in the April 2022 *World Economic Outlook*. Low-income developing countries are as defined by the IMF. Emerging market and middle-income economies comprise those not classified as advanced economies or low-income developing countries.",
  data: {
    labels: [
      formatLabel("Low-income developing countries", 30),
      formatLabel("Emerging market and middle-income economies", 30),
      formatLabel("Advanced economies", 30),
      formatLabel("Multi-regional", 30),
    ],
    datasets: [
      {
        label: "",
        data: [47.9, 46.8, 4.4, 0.8],
        backgroundColor: "#508C34",
      },
    ],
  },
  options: optionsHorizontalBar,
}

export default cd_direct_recovery_income;